import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '<',
        sites: '<'
    },
    template: `
        <div class="well narrow">
            <form role="form" class="form"">
                <div class="form nomargin">
                    <form-wrapper form="vm.form">
                        <form-row-wide error="vm.form.errors.courseI18ns[vm.defaultLanguage].name" class="row row-wide mb-5">
                            <div class="row row-wide">
                                <label class="label w100p nomargin">{{ 'course.Name' | translate }} *</label>
                                    <div class="items w100p">
                                        <input
                                            ng-disabled="!vm.canManageCourse"
                                            type="text"
                                            class="form-control w100p"
                                            ng-model="vm.form.model.courseI18ns[vm.defaultLanguage].name"/>
                                        <form-row-wide-error></form-row-wide-error>
                                    </div>
                            </div>
                        </form-row-wide>
                        <br />
                        <form-row-wide error="vm.form.errors.courseSiteIds" class="row row-wide mb-5">
                            <div class="row row-wide">
                                <label class="label w100p">{{ 'course.Access' | translate }} *</label>
                                <div class="items w100p">
                                    <div
                                        ng-dropdown-multiselect=""
                                        options="vm.multiFilter.sites.options"
                                        events="vm.multiFilter.sites.events"
                                        selected-model="vm.multiFilter.sites.models"
                                        extra-settings="vm.multiFilter.sites.settings"
                                        translation-texts="vm.multiFilter.sites.translations"
                                    >
                                    </div>
                                    <form-row-wide-error></form-row-wide-error>
                                </div>
                            </div>
                        </form-row-wide>
                        <div style="display: flex; justify-content: space-between; width: 100%; margin-top: 20px;">
                            <div style="display: flex; gap: 10px;">
                                <a
                                    ng-click="vm.save($event, false)"
                                    ng-if="vm.canManageCourse"
                                    ng-disabled="vm.isSaving"
                                    ng-class="{'loading': vm.isSaving && vm.savingType === 'course'}"
                                    style="white-space: nowrap"
                                    class="btn main">{{ 'course.Create course' | translate }}</a>
                                <a
                                    ng-click="vm.save($event, true)"
                                    ng-if="vm.canManageCourse && vm.TokenService.isGuidanceModuleEnabled() && vm.TokenService.hasPrivilege('GUIDANCE_MODIFY')"
                                    ng-disabled="vm.isSaving"
                                    ng-class="{'loading': vm.isSaving && vm.savingType === 'guidance'}"
                                    style="white-space: nowrap"
                                    class="btn bordered02">{{ 'course.Create guidance' | translate }}</a>
                            </div>
                            <div>
                                <a ui-sref="authorized.courses.courses.list()" class="btn bordered02">
                                {{ 'general.Cancel' | translate }}
                                </a>
                            </div>
                        </div>
                    </form-wrapper>
                </div>
            </form>
        </div>
    `
})
export default class {
    constructor (FormFactory, $state, $translate, lodash, SiteService, ModalService, COURSE_SITE_ACCESS_ENUM,
        SiteResource, CourseService, ResponseService, TokenService, CourseResource, toastr,
        ROLE_COMPANY_MODULE_PRIVILEGE_ENUM
    ) {
        this.FormFactory = FormFactory;
        this.$translate = $translate;
        this.$state = $state;
        this.lodash = lodash;
        this.toastr = toastr;
        this.SiteService = SiteService;
        this.ModalService = ModalService;
        this.TokenService = TokenService;
        this.COURSE_SITE_ACCESS_ENUM = COURSE_SITE_ACCESS_ENUM;
        this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM = ROLE_COMPANY_MODULE_PRIVILEGE_ENUM;
        this.siteResource = SiteResource;
        this.CourseService = CourseService;
        this.ResponseService = ResponseService;
        this.CourseResource = CourseResource;
        this.defaultLanguage = TokenService.getCompanyLanguage();
    }
    $onInit () {
        this.loader = false;
        this.isSaving = false;
        this.savingType = null;

        this.form = this.FormFactory.createFromResource(this.course);
        this.form.model.fields = {};

        this.course.siteAccess = this.COURSE_SITE_ACCESS_ENUM.KEYS.SPECIFIED_SITES;
        if (this.showAllSites()) {
            this.course.siteAccess = this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
        }

        this.initMultiFilter();
        this.canManageCourse = this.CourseService.canManageCourse(this.course);

        this.form.model.siteAccess = this.course.siteAccess;
    }

    showAllSites () {
        return this.SiteService.hasAccessToAllSites(this.sites)
            || this.course.siteAccess === this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
    }

    /**
     * This callback makes sure that all sites option is always selected alone
     * - if all sites is selected uncheck every other option
     * - if any actual site option is selected unchecks all sites option
     * @returns {Function}
     */
    getSiteItemCallback () {
        return (item) => {
            const { multiFilter } = this;

            // If "All sites" option is selected (item.value is null)
            if (item.value === null) {
                // Keep only the "All sites" option
                multiFilter.sites.models = [this.allSitesOption];
                this.form.model.siteAccess = this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
            }
            else {
                // If a specific site is selected, remove the "All sites" option
                multiFilter.sites.models = multiFilter.sites.models.filter(model => model.value !== null);
                this.form.model.siteAccess = this.COURSE_SITE_ACCESS_ENUM.KEYS.SPECIFIED_SITES;
            }
        };
    }

    getSiteOptions () {
        const siteOptions = [];
        const cb = site => {
            return {
                value: site.id,
                label: site.name
            };
        };

        if (this.showAllSites()) {
            siteOptions.push(this.allSitesOption);
        }

        this.lodash.forEach(this.sites, site => {
            siteOptions.push(cb(site));
        });

        if (this.course.sites && this.course.sites.length) {
            this.lodash.forEach(this.course.sites, site => {
                siteOptions.push(cb(site));
            });
        }

        return this.lodash.uniqBy(siteOptions, option => option.value);
    }


    getSelectedFieldOptions (fieldOptions) {
        let selectedOptions = [];
        if (this.course.fields && this.course.fields.length) {
            const selectedFieldIds = this.course.fields.map(field => field.id);
            selectedOptions = fieldOptions.filter(option => this.lodash.includes(selectedFieldIds, option.value));
        }
        return selectedOptions;
    }

    initMultiFilter () {
        this.allSitesOption = {
            value: null,
            label: this.$translate.instant('general.All sites')
        };
        const siteOptions = this.getSiteOptions();
        const selectedSiteOptions = this.getSelectedSiteOptions(siteOptions);

        const fieldOptions = [];
        const selectedFieldOptions = this.getSelectedFieldOptions(fieldOptions);

        this.multiFilter = {
            sites: {
                models: selectedSiteOptions,
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: false,
                    smartButtonMaxItems: 5,
                    smartButtonTextConverter: (itemText) => itemText
                },
                events: {
                    onItemDeselect: this.getSiteItemCallback(),
                    onItemSelect: this.getSiteItemCallback()
                },
                translations: {
                    buttonDefaultText: this.$translate.instant('filter.Select')
                }
            },
            fields: {
                options: fieldOptions,
                models: selectedFieldOptions,
                settings: {
                    enableSearch: true,
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: false,
                    smartButtonMaxItems: 10,
                    smartButtonTextConverter: (itemText) => itemText
                },
                translations: {
                    buttonDefaultText: this.$translate.instant('filter.Select')
                }
            }
        };
    }

    /**
     * Selected options have to be composed of siteOptions objects
     * they have to be references of each-other for multiselect to work
     * @param siteOptions
     * @returns {[]}
     */
    getSelectedSiteOptions (siteOptions) {
        let selectedOptions = [];
        if (this.course.sites && this.course.sites.length) {
            const selectedSiteIds = this.course.sites.map(site => site.id);
            selectedOptions = siteOptions.filter(option => this.lodash.includes(selectedSiteIds, option.value));
        }
        else if (this.course.siteAccess === this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES) {
            selectedOptions.push(this.allSitesOption);
        }
        else {
            selectedOptions.push(...siteOptions);
        }
        return selectedOptions;
    }

    beforeSave () {
        this.form.invalid = false;
        this.form.model.expirationMonths = 0;
        this.form.model.courseSiteIds = this.multiFilter.sites.models.map(siteOption => siteOption.value);

        const currentUser = this.TokenService.getUser();
        this.form.model.ownerId = currentUser.id;

        if (!this.lodash.has(this.form.model.courseI18ns, this.defaultLanguage)) {
            // we have to add empty name because this form is sent via upload which removes empty obj ({})
            this.lodash.set(this.form.model, `courseI18ns.${this.defaultLanguage}.name`, '');
        }

        if (!this.form.model.courseSiteIds || this.form.model.courseSiteIds.length === 0) {
            this.form.errors.courseSiteIds = this.$translate.instant('Site access cannot be blank');
            this.form.invalid = true;
        }

        this.form.model.fields = [];
        if (this.form.model.siteAccess === this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES) {
            this.form.model.courseSiteIds = [];
        }
        else {
            this.form.model.courseSiteIds = this.multiFilter.sites.models.map(siteOption => siteOption.value);
        }
    }

    save (e, isGuidance = false) {
        // Prevent multiple simultaneous save operations
        if (this.isSaving) {
            e.preventDefault();
            return;
        }
        this.beforeSave();
        this.form.model.isGuidance = isGuidance;

        this.isSaving = true;
        this.savingType = isGuidance ? 'guidance' : 'course';

        this.CourseResource.create({ expand: 'courseVersions' },
                this.lodash.assign({}, {}, this.form.model)
            )
            .$promise
            .then((response) => {
                this.$state.go('authorized.courses.courses.edit.version.edit.training', {
                    id: response.id,
                    versionId: response.courseVersions[0].id
                });
                this.toastr.success(this.$translate.instant('general.Changes saved'));
            }).catch((resp) => {
                this.form.errors = this.ResponseService.parseErrors(resp);
                this.toastr.error(this.$translate.instant('general.Something went wrong'));
                this.loader = false;
                this.isSaving = false;
                this.savingType = null;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/add/index.js